<template>
    <v-dialog v-model="dialog"
              scrollable
              width="80%"
              max-width="1013px"
              :fullscreen="$vuetify.breakpoint.xsOnly">
        <template v-slot:activator="{ on }">
            <span @click.stop="openDialog">
                <slot></slot>
            </span>
        </template>
        <v-card v-if="static">
            <v-card-text class="pt-6">
                <anchor-content :content="static.content"/>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">{{ $vuetify.lang.t('$vuetify.buttons.close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    // models
    import AnchorContent from '../components/AnchorContent';
    import StaticPage from '../models/StaticPage';

    export default {
        name: 'static-content-dialog',
        components: {
            AnchorContent,
        },
        props: {
            slug: {},
            open: {
                default: false,
                type: Boolean,
            },
        },
        data() {
            return {
                dialog: false,
            }
        },
        computed: {
            static() {
                return StaticPage.getBySlug(this.slug);
            },
        },
        methods: {
            openDialog() {
                this.dialog = true;
            },
        },
        mounted() {
            this.dialog = !!this.open;
        }
    }
</script>
